export function isAuthError(error) {
  if (!error) return false;
  const code = error.code || error.error?.code || '';
  const message = (error.message || '').toLowerCase();
  
  return (
    code.includes('auth/') ||
    code === 'permission-denied' ||
    code === 'unauthenticated' ||
    message.includes('permission denied') ||
    message.includes('unauthenticated') ||
    message.includes('token expired')
  );
}

export function triggerAuthModal() {
  window.dispatchEvent(new CustomEvent('artpingpong-auth-expired'));
}

export function handleAuthError(error) {
  if (isAuthError(error)) {
    console.warn('[Auth] Session expired or permission denied:', error);
    triggerAuthModal();
    return true;
  }
  return false;
}

export function withAuthErrorHandling(fn) {
  return async (...args) => {
    try {
      return await fn(...args);
    } catch (error) {
      if (handleAuthError(error)) {
        throw new Error('Session expired. Please sign in again.');
      }
      throw error;
    }
  };
}
